/**
 * I corpi in ingresso dell'identità: entrare, confermare, amministrare utenti.
 *
 * I ruoli stanno in `ruoli.ts`, che serve anche alle letture.
 */
import { z } from 'zod';
import { zRuolo } from './roles.js';
export const zAccesso = z.object({
    login: z.string().min(1).max(64),
    password: z.string().min(1).max(256),
});
/**
 * La conferma d'identità: solo la password.
 *
 * Il login **non** si manda: si conferma la sessione che si ha già, letta dal
 * token. Accettarlo dal corpo vorrebbe dire permettere di confermare per conto
 * di un altro.
 */
export const zConferma = z.object({
    password: z.string().min(1).max(256),
});
/**
 * Google sign-in and confirmation: the credential Google's button hands to
 * the browser, a JWT signed by Google.
 *
 * Who the person is comes from the credential, not the body: as with the
 * password confirmation, a login sent along is dropped.
 */
export const zAccessoGoogle = z.object({
    credential: z.string().min(1).max(4096),
});
/** Lowercase: Google returns the email with whatever capitals it was created with. */
const zEmail = z.string().trim().toLowerCase().pipe(z.string().email('email non valida').max(254));
/**
 * La lunghezza minima è 12 e non 8.
 *
 * Non è una moda: qui non c'è un secondo fattore, la sessione dura un turno e
 * la stessa password vale come firma sui gesti attribuiti — timer, scarti,
 * deroghe. Una password corta renderebbe indovinabile una firma.
 */
export const zPasswordNuova = z
    .string()
    .min(12, 'almeno 12 caratteri: questa password firma anche i gesti attribuiti')
    .max(256);
/**
 * A user signs in with Google (the email), with a password, or both.
 *
 * In production operators are created with the email only; the password stays
 * with the administrator, as the emergency door if Google does not answer. In
 * development and tests users are still created with a password.
 */
export const zNuovoUtente = z
    .object({
    login: z
        .string()
        .min(2)
        .max(64)
        .regex(/^[a-zA-Z0-9._-]+$/, 'lettere, cifre, punto, trattino e trattino basso'),
    nome: z.string().min(1).max(120),
    email: zEmail.optional(),
    password: zPasswordNuova.optional(),
    ruoli: z.array(zRuolo).min(1, 'un utente senza ruoli non potrebbe fare niente'),
})
    .refine((u) => u.email !== undefined || u.password !== undefined, {
    message: "serve un'email o una password: senza nessuna delle due non si entra",
});
export const zCambioPassword = z.object({ password: zPasswordNuova });
/** `null` removes Google sign-in. */
export const zCambioEmail = z.object({ email: zEmail.nullable() });
export const zCambioRuoli = z.object({
    ruoli: z.array(zRuolo).min(1, 'un utente senza ruoli non potrebbe fare niente'),
});
//# sourceMappingURL=auth.js.map